/* ============================================================
   THE CANINE CARPENTER — THEME JS
   ============================================================ */

(function(){
  'use strict';

  /* Mobile nav toggle */
  const menuBtn = document.querySelector('.mob-menu-btn');
  const mobNav  = document.querySelector('.mob-nav');
  const stickyWrapper = document.querySelector('.site-header-sticky');

  function getNavBottom(){
    /* Gets the bottom edge of the sticky header (nav + any visible announcement bar) */
    if(stickyWrapper) return stickyWrapper.getBoundingClientRect().bottom;
    const nav = document.querySelector('.nav');
    return nav ? nav.getBoundingClientRect().bottom : 60;
  }

  function openNav(){
    const top = getNavBottom();
    mobNav.style.top = top + 'px';
    mobNav.classList.add('open');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('nav-open');
  }

  function closeNav(){
    mobNav.classList.remove('open');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('nav-open');
  }
  window.closeNav = closeNav;

  if(menuBtn && mobNav){
    menuBtn.addEventListener('click', function(){
      mobNav.classList.contains('open') ? closeNav() : openNav();
    });

    /* Close on link click */
    mobNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', closeNav);
    });
  }

})();

/* ── Product image carousel ── */
(function(){
  const track = document.getElementById('carousel-track');
  if(!track) return;

  const slides = track.querySelectorAll('.product-carousel__slide');
  const dots   = document.querySelectorAll('.carousel-dot');
  const total  = slides.length;
  let current  = 0;

  function getSlideWidth(){
    return track.parentElement.offsetWidth;
  }

  function goTo(index){
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * getSlideWidth()) + 'px)';
    dots.forEach(function(d, i){ d.classList.toggle('active', i === current); });
  }

  /* Re-apply transform on resize so position doesn't drift */
  window.addEventListener('resize', function(){
    track.style.transition = 'none';
    track.style.transform = 'translateX(-' + (current * getSlideWidth()) + 'px)';
    requestAnimationFrame(function(){
      track.style.transition = '';
    });
  });

  window.carouselMove = function(dir){ goTo(current + dir); };
  window.carouselGoTo = function(i){ goTo(i); };

  /* Touch / swipe support */
  var startX = 0, isDragging = false;
  var carousel = document.getElementById('product-carousel');

  carousel.addEventListener('touchstart', function(e){
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  carousel.addEventListener('touchend', function(e){
    if(!isDragging) return;
    var diff = startX - e.changedTouches[0].clientX;
    if(Math.abs(diff) > 40){ goTo(current + (diff > 0 ? 1 : -1)); }
    isDragging = false;
  }, { passive: true });

})();

/* ── Featured products — per-card image auto-advance on hover ── */
(function(){
  document.querySelectorAll('.prod-img-carousel').forEach(function(card){
    const slides = card.querySelectorAll('.prod-img-slide');
    const dots   = card.querySelectorAll('.prod-img-dot');
    if(slides.length < 2) return;

    let current = 0, timer = null;

    function showSlide(i){
      slides[current].style.opacity = '0';
      dots[current] && dots[current].classList.remove('active');
      current = i % slides.length;
      slides[current].style.opacity = '1';
      dots[current] && dots[current].classList.add('active');
    }

    function start(){
      timer = setInterval(function(){ showSlide(current + 1); }, 900);
    }
    function stop(){
      clearInterval(timer);
      showSlide(0);
    }

    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);

    /* Touch: swipe to next */
    var tx = 0;
    card.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; }, {passive:true});
    card.addEventListener('touchend', function(e){
      if(e.changedTouches[0].clientX - tx < -40) showSlide(current + 1);
      if(e.changedTouches[0].clientX - tx > 40)  showSlide(current === 0 ? slides.length - 1 : current - 1);
    }, {passive:true});
  });
})();

/* ── Homepage scroll animations ── */
(function(){
  /* Fade-in sections and cards */
  const els = document.querySelectorAll('.fade-in, .fade-in-up');
  if(els.length){
    const obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin:'0px 0px -40px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  /* Section headings — reveal on scroll */
  const headings = document.querySelectorAll('.section-reveal');
  if(headings.length){
    const hObs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.style.animationPlayState = 'running';
          hObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    headings.forEach(function(el){
      el.style.animationPlayState = 'paused';
      hObs.observe(el);
    });
  }
})();

/* ── Product description read-more toggle ── */
(function(){
  var body   = document.getElementById('desc-body');
  var toggle = document.getElementById('desc-toggle');
  if (!body || !toggle) return;

  toggle.addEventListener('click', function(){
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      body.classList.remove('desc-body--expanded');
      body.classList.add('desc-body--collapsed');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('.desc-toggle__label').textContent = 'Read more';
    } else {
      body.classList.remove('desc-body--collapsed');
      body.classList.add('desc-body--expanded');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.querySelector('.desc-toggle__label').textContent = 'Read less';
    }
  });
})();

/* ── Gold ambient particles — homepage dark sections only ── */
(function(){
  /* Only run on homepage */
  if(!document.body.classList.contains('template-index')) return;

  var canvas = document.createElement('canvas');
  canvas.id  = 'tcc-particles';
  canvas.style.cssText = [
    'position:fixed',
    'inset:0',
    'width:100%',
    'height:100%',
    'pointer-events:none',
    'z-index:0',
    'mix-blend-mode:screen'
  ].join(';');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var W, H, particles = [];
  var GOLD = '212,160,23';
  var COUNT = 38;

  /* Dark section selectors — only render inside these */
  var darkSelectors = ['.hero', '.brand', '.bespoke-band'];

  function resize(){
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }
  window.addEventListener('resize', resize);
  resize();

  function rand(min, max){ return min + Math.random() * (max - min); }

  function makeParticle(){
    return {
      x:     rand(0, W),
      y:     rand(0, H),
      r:     rand(0.8, 2.2),
      vx:    rand(-0.12, 0.12),
      vy:    rand(-0.18, -0.05),
      alpha: rand(0.04, 0.18),
      pulse: rand(0, Math.PI * 2),
      speed: rand(0.004, 0.010)
    };
  }

  for(var i = 0; i < COUNT; i++) particles.push(makeParticle());

  /* Cache dark section rects each frame (cheap since we only have ~3 els) */
  function getDarkRects(){
    var rects = [];
    darkSelectors.forEach(function(sel){
      var el = document.querySelector(sel);
      if(!el) return;
      var r = el.getBoundingClientRect();
      if(r.bottom > 0 && r.top < H) rects.push(r);
    });
    return rects;
  }

  function inAnyRect(x, y, rects){
    for(var i = 0; i < rects.length; i++){
      var r = rects[i];
      if(x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return true;
    }
    return false;
  }

  function draw(){
    ctx.clearRect(0, 0, W, H);
    var rects = getDarkRects();

    particles.forEach(function(p){
      /* Drift */
      p.x += p.vx;
      p.y += p.vy;
      p.pulse += p.speed;

      /* Wrap */
      if(p.y < -4)  p.y = H + 4;
      if(p.x < -4)  p.x = W + 4;
      if(p.x > W+4) p.x = -4;

      /* Only draw if inside a dark section */
      if(!inAnyRect(p.x, p.y, rects)) return;

      var a = p.alpha * (0.6 + 0.4 * Math.sin(p.pulse));
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + GOLD + ',' + a.toFixed(3) + ')';
      ctx.fill();
    });

    requestAnimationFrame(draw);
  }

  /* Respect reduced motion */
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    /* Skip particles entirely on mobile — saves battery and CPU */
    if(window.innerWidth >= 768){
      draw();
    }
  }
})();
